import $ from 'jquery';

const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  const t = exdays * 24 * 60 * 60 * 1000;
  d.setTime(d.getTime() + t);
  const expires = `expires=${d.toGMTString()}`;
  document.cookie = `${cname}=${cvalue}; ${expires};path=/`;
};

function CookieBar() {
  $('.CookieBar-btn').click((e) => {
    e.preventDefault();
    $('.CookieBar').hide();
    setCookie('accept_cookie', true, 30);
  });
}

export default CookieBar;



// WEBPACK FOOTER //
// ./assets/src/js/modules/CookieBar.js